// Global Wishlist Manager
class WishlistManager {
  constructor() {
    this.init();
  }

  init() {
    this.updateWishlistCount();
    this.bindEvents();
  }

  bindEvents() {
    // Listen for wishlist updates
    window.addEventListener('wishlistUpdated', (event) => {
      this.updateWishlistCount();
    });

    // Listen for cart updates
    window.addEventListener('cartUpdated', (event) => {
      this.updateCartCount();
    });
  }

  updateWishlistCount() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const count = wishlist.length;
    
    // Update all wishlist counters
    const counters = document.querySelectorAll('.wishlist-count, [data-wishlist-count]');
    counters.forEach(counter => {
      counter.textContent = count;
      counter.style.display = count > 0 ? 'inline' : 'none';
    });

    // Update wishlist badges
    const badges = document.querySelectorAll('.wishlist-badge');
    badges.forEach(badge => {
      badge.style.display = count > 0 ? 'block' : 'none';
    });
  }

  updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const counters = document.querySelectorAll('.cart-count, [data-cart-count]');
        counters.forEach(counter => {
          counter.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  // Remove item from wishlist with animation
  removeFromWishlist(productId, variantId = null) {
    const productCard = document.querySelector(`[data-product-id="${productId}"]`);
    
    if (productCard) {
      // Add removing animation
      productCard.style.transition = 'all 0.3s ease';
      productCard.style.transform = 'scale(0.8)';
      productCard.style.opacity = '0';
      
      setTimeout(() => {
        this.removeFromStorage(productId, variantId);
        productCard.remove();
        
        // Check if wishlist is empty and show empty state
        this.checkEmptyState();
        
        // Show success notification
        this.showNotification('Product removed from wishlist', 'success');
        
        // Update heart button states globally
        this.updateHeartButtonStates();
      }, 300);
    } else {
      // Fallback for when card is not found
      this.removeFromStorage(productId, variantId);
    }
  }
  
  // Remove from localStorage only
  removeFromStorage(productId, variantId = null) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    
    wishlist = wishlist.filter(item => {
      if (variantId) {
        return !(item.id === productId && item.variantId === variantId);
      }
      return item.id !== productId;
    });
    
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    this.updateWishlistCount();
    
    // Dispatch update event
    window.dispatchEvent(new CustomEvent('wishlistUpdated', { 
      detail: { count: wishlist.length } 
    }));
    
    // Update heart button states
    this.updateHeartButtonStates();
  }
  
  // Check if wishlist is empty and show appropriate state
  checkEmptyState() {
    const wishlistItems = document.getElementById('wishlist-items');
    const emptyState = document.getElementById('wishlist-empty');
    
    if (wishlistItems && emptyState) {
      const remainingItems = wishlistItems.children.length;
      
      if (remainingItems === 0) {
        emptyState.style.display = 'block';
        wishlistItems.style.display = 'none';
      }
    }
  }
  
  // Show notification
  showNotification(message, type) {
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 20px;
      border-radius: 5px;
      color: white;
      font-weight: bold;
      z-index: 9999;
      opacity: 0;
      transform: translateX(100%);
      transition: all 0.3s ease;
      background-color: ${type === 'success' ? '#28a745' : '#dc3545'};
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.opacity = '1';
      notification.style.transform = 'translateX(0)';
    }, 100);
    
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
  
  // Update heart button states across the site
  updateHeartButtonStates() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const wishlistIds = wishlist.map(item => item.id);
    
    // Update all heart buttons on the page
    document.querySelectorAll('[data-product-id]').forEach(heartBtn => {
      const productId = heartBtn.getAttribute('data-product-id');
      const icon = heartBtn.querySelector('i');
      
      if (wishlistIds.includes(productId)) {
        heartBtn.classList.add('liked');
        if (icon) {
          icon.classList.remove('bi-heart');
          icon.classList.add('bi-heart-fill');
        }
        heartBtn.style.color = '#e74c3c';
      } else {
        heartBtn.classList.remove('liked');
        if (icon) {
          icon.classList.remove('bi-heart-fill');
          icon.classList.add('bi-heart');
        }
        heartBtn.style.color = '#1E2938';
      }
    });
    
    // Also update wishlist buttons
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const productId = btn.dataset.productId;
      if (wishlistIds.includes(productId)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  // Check if item is in wishlist
  isInWishlist(productId, variantId = null) {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    
    return wishlist.some(item => {
      if (variantId) {
        return item.id === productId && item.variantId === variantId;
      }
      return item.id === productId;
    });
  }

  // Get wishlist items
  getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  }
}

// Initialize wishlist manager when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.wishlistManager = new WishlistManager();
});

// Make functions globally available
window.updateWishlistCount = function() {
  if (window.wishlistManager) {
    window.wishlistManager.updateWishlistCount();
  }
};

window.removeFromWishlist = function(productId, variantId) {
  if (window.wishlistManager) {
    window.wishlistManager.removeFromWishlist(productId, variantId);
  }
};